import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import '../../styles/discover.less';
import '../../styles/products-directory.less';
import DiscoverIconWhite from '../common/components/DiscoverIconWhite';
import SearchIncosDiscoverIcon from '../common/components/SearchIncosDiscoverIcon';
import Utils from '../common/Utils';
import { DiscoverConstants } from '../common/Constants';
import dtmTags from '../common/dtmTags';

class DiscoverProducts extends React.Component {
    render() {
        let { products } = this.props;
        products = products ?? [];

        const discoverConfig = Utils.getDiscoverConfig();
        const discoverEventConfig = Utils.getDiscoverEventConfig(this.props.eventEditionId)
        const discoverImageBaseUrl = discoverConfig.discoverImageUrl + discoverEventConfig.discoverEventId + '/';
        let covaloProducts = [];
        for(let i = 0; i < products.length; i++) {
            let imageSrc = DiscoverConstants.noImagePlaceHolderSrc;
            if(products[i].document.event.images) {
                imageSrc = discoverImageBaseUrl + products[i].document.event.images[0].reference;
            }
            else if(products[i].document.company.images) {
                const companyLogo = products[i].document.company.images.filter(x => x.section === 'LOGO');
                imageSrc = companyLogo.length ? discoverImageBaseUrl
                    + companyLogo[0].reference : DiscoverConstants.noImagePlaceHolderSrc;
            }

            const customClasses = `${Classes.productTile} ${Classes.enhancement} ${Classes.productDirectory.productItem}`;
            covaloProducts.push(
                <Col xs={16} sm={6} md={4} className={customClasses} key={products[i].document.old_key}>
                    <div>
                        <a href={`${discoverConfig.discoverPageUrl}product/${products[i].document.old_key}`}
                            data-dtm={dtmTags.productDirectory.discoverBanner.product}
                            data-dtm-attributes={JSON.stringify({ productId: products[i].document.key,
                                exhibitorId: products[i].document.company.name})}>
                            <img className={Classes.productDirectory.discoverProductImage} src={imageSrc} />
                            <h4 className={Classes.productDirectory.discoverProductName} >{products[i].document.name}</h4>
                            <div className={Classes.productExhibitorName}>
                                {products[i].document.company.name}
                            </div>
                        </a>
                    </div>
                </Col>);
        }

        let queryParams = this.props.query ? '&query=' + this.props.query : '';
        if(this.props.filters.length) {
            const groupedFilters = Utils.groupBy(this.props.filters, 'field', 'value');
            Object.keys(groupedFilters).forEach((filterCategory) => {
                queryParams = queryParams + '&' + filterCategory + '=' + groupedFilters[filterCategory].join('|');
            });
        }
        let searchPageLink = `${discoverConfig.discoverPageUrl}search/ingredients?segment=personalcare${queryParams}`;
        let certifications  =  [];
        discoverConfig.certifications.forEach(certification => {
            const searchPageLinkWithCertification = `${searchPageLink}&certifications=${certification}`;
            certifications.push(<a href={encodeURI(searchPageLinkWithCertification)}><img className={Classes.productDirectory.certificationImage} src={`${discoverConfig.certificationsImageUrl}${certification}` } data-dtm={dtmTags.productDirectory.discoverBanner.certifications} /></a>);
        });

        let numberOfProducts = this.props.total ? this.props.total : 0;
        numberOfProducts = numberOfProducts.toLocaleString('en-US');
        const translations = this.props.translations.productDirectory.discover;
        const encodedSearchPageLink = encodeURI(searchPageLink);
        return  <div className={Classes.productDirectory.discoverBanner}>
                    <a href={encodedSearchPageLink}>
                        <div className={Classes.productDirectory.navigationFlexbox} data-dtm={dtmTags.productDirectory.discoverBanner.productCount} >
                            <div className={Classes.productDirectory.productCount}>
                                {translations.exploreText} {numberOfProducts} {translations.moreResultsText}
                            </div>
                            <div className={Classes.productDirectory.discoverIcon}>
                                <DiscoverIconWhite />
                            </div>
                        </div>
                    </a>
                    <Row>{covaloProducts}</Row>
                    <a href={encodedSearchPageLink} className={Classes.productDirectory.browseSearchTextBoxLink}>
                        <div className={Classes.productDirectory.browseSearchTextBox} data-dtm={dtmTags.productDirectory.discoverBanner.productCount}>
                            <span className={Classes.productDirectory.browseSearchText}>
                                {translations.browseSearchText} <span className={Classes.productDirectory.certificationSustainabilityText}>{translations.certificationsSustainabilityText}</span>
                            </span>
                            <span className={Classes.productDirectory.browseSearchText}>
                                {translations.andMoreText}
                            </span>
                        </div>
                    </a>
                    <div className={Classes.productDirectory.certificationBox}>
                        {certifications}
                    </div>
                    <a href={encodedSearchPageLink}>
                        <button className={Classes.productDirectory.searchDiscoverButton} data-dtm={dtmTags.productDirectory.discoverBanner.productCount}>
                            <SearchIncosDiscoverIcon />
                        </button>
                    </a>
                </div>
    }
}

DiscoverProducts.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object),
    total: PropTypes.number,
    query: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.object),
    translations: PropTypes.object.isRequired,
    eventEditionId: PropTypes.string.isRequired
  };

export default DiscoverProducts;
